import React from 'react';
import styled from 'styled-components';

const AlertContainer = styled.div`
  /* The styles are mostly in GlobalStyles.css with .alert class, 
     but we can add component-specific overrides or logic here if needed. */
`;

const Alert = ({ type = 'error', message, children, style }) => {
    if (!message && !children) return null;

    const getIcon = () => {
        switch (type) {
            case 'error': return '✕';
            case 'success': return '✓';
            case 'warning': return '⚠';
            default: return 'ℹ';
        }
    };

    return (
        <div className={`alert alert-${type}`} style={style}>
            <span style={{ fontSize: '1.2rem', lineHeight: 1 }}>{getIcon()}</span>
            <div>{message || children}</div>
        </div>
    );
};

export default Alert;
